import { TFunction } from 'i18next'

import { StoreError, StoreErrorName } from '../error'

import { BatteryState, Connection, Diagnostic, TestState } from './types'

export function summaryTitleForState(state: TestState, t?: TFunction) {
  switch (state) {
    case TestState.IDLE:
      return t ? t('Test not started') : 'Test not started'
    case TestState.READY:
      return t ? t('Test aborted before start') : 'Test aborted before start'
    case TestState.STARTING:
      return t ? t('Test aborted at startup') : 'Test aborted at startup'
    case TestState.WAITING:
      return t ? t('Test aborted before charging') : 'Test aborted before charging'
    case TestState.SCANNING:
      return t ? t('Test aborted at bluetooth scanning') : 'Test aborted at bluetooth scanning'
    case TestState.RANGING:
      return t ? t('Test aborted at bluetooth ranging') : 'Test aborted at bluetooth ranging'
    case TestState.READING:
      return t ? t('Test aborted during reading characteristics') : 'Test aborted during reading characteristics'
    case TestState.COMPLETED:
      return t ? t('Test completed succesful') : 'Test completed succesful'
    case TestState.FAILED:
      return t ? t('Test failed') : 'Test failed'
  }
}

export function infoForError(error?: StoreError, t?: TFunction) {
  switch (error?.name) {
    case StoreErrorName.BLUETOOTH_OFF:
    case StoreErrorName.BLUETOOTH_DENIED:
    case StoreErrorName.LOCATION_DENIED:
    case StoreErrorName.CHARGING_FAILED:
    case StoreErrorName.STARTING_FAILED:
    case StoreErrorName.SCANNING_FAILED:
    case StoreErrorName.CONNECTING_FAILED:
    case StoreErrorName.READING_FAILED:
    case StoreErrorName.WRITING_FAILED:
    case StoreErrorName.FIRMWARE_FAILED:
      return error?.message ? `${t ? t('Error message') : 'Error message'}: ${error?.message}` : ''
    case StoreErrorName.RANGING_FAILED:
      return error.info?.found
        ? t
          ? (t('Expected beacon {{expected}} but found {{found}}.', error.info) as string)
          : `Expected beacon ${error.info?.expected} but found ${error.info?.found}.`
        : error?.message
          ? `${t ? t('Error message') : 'Error message'}: ${error?.message}`
          : ''
    case StoreErrorName.VALIDATION_FAILED:
      return t
        ? (t('Expected device {{expected}} but found {{found}}.', error.info) as string)
        : `Expected device ${error.info?.expected} but found ${error.info?.found}.`
    default:
      return ''
  }
}

export function titleForBatteryState(state: BatteryState, t?: TFunction) {
  switch (state) {
    case BatteryState.CHARGING:
      return t ? t('Charging') : 'Charging'
    case BatteryState.FULL:
      return t ? t('Full') : 'Full'
    case BatteryState.UNPLUGGED:
      return t ? t('Unplugged') : 'Unplugged'
    case BatteryState.UNKNOWN:
      return t ? t('Unknown') : 'Unknown'
  }
}

export function titleForConnection(connection: Connection, t?: TFunction) {
  switch (connection) {
    case Connection.OCCUPIED:
      return t ? t('Occupied') : 'Occupied'
    case Connection.UNOCCUPIED:
      return t ? t('Free') : 'Free'
    case Connection.CONNECTED:
      return t ? t('Connected') : 'Connected'
    case Connection.DISCONNECTED:
      return t ? t('Disconnected') : 'Disconnected'
    default:
      return t ? t('Sensor connection could not be verified') : 'Sensor connection could not be verified'
  }
}

export function titleForDiagnostic(diagnostic: Diagnostic, t?: TFunction) {
  switch (diagnostic) {
    case Diagnostic.Attaching:
      return t
        ? t('Device is powering up and will attach to the network soon')
        : 'Device is powering up and will attach to the network soon'
    case Diagnostic.PowerUp:
      return t
        ? t('Device is waiting for power supply to be sufficient')
        : 'Device is waiting for power supply to be sufficient'
    case Diagnostic.Sending:
      return t ? t('Device is attached and sending a package') : 'Device is attached and sending a package'
    case Diagnostic.Waiting:
      return t ? t('Device is attached and waiting for a package') : 'Device is attached and waiting for a package'
    case Diagnostic.ErrorNotAttached:
      return t ? t('Device is not attached due to an error') : 'Device is not attached due to an error'
    case Diagnostic.ErrorAttached:
      return t
        ? t('Device is attached but there was an error sending a package')
        : 'Device is attached but there was an error sending a package'
    default:
      return t ? t('Device state is unknown') : 'Device state is unknown'
  }
}
